<template>
  <div
      :class="'justify-'+messageAlign"
      class="px-3 pb-3 d-flex"
  >
    <v-sheet
        v-if="message.type==='event'"
        class="body-2 pa-2 muted1 text-center caption grey lighten-4"
        max-width="400"
        rounded
    >
      {{ message.text }} в {{ $tools.dateFormat(message.created) }}
    </v-sheet>
    <v-sheet
        v-else
        :color="messageUser?.id===$store.state.user?.id ? 'light-green lighten-5' : 'white'" class="d-inline-block text-left overflow-hidden"
        rounded
        style="border:solid 1px #DDD !important;max-width:80%"
    >
      <div :class="messageClass">
        <div class="mx-2 py-1">
          <div v-if="messageUser===null" class="caption">
            {{ message.dialogUser.name }}
          </div>
          <a v-else :href="'/panel/user/'+messageUser?.type+'/'+messageUser?.id+'/'" class="caption" target="_blank">
            {{ $tools.userFullName(messageUser) }}
          </a>
          <div v-if="message.text!==null" class="body-2 mt-1 mb-2" v-html="$tools.nl2br(message.text)"></div>
          <div v-for="attach in message.dialogMessageAttachs" :key="attach.id" class="body-2 mt-1 mb-2">
            <v-sheet
                v-if="$tools.getFileTypeByPath(attach.url).includes('image')"
                class="clickable overflow-hidden"
                color="black" height="250" rounded width="250" @click="$tools.openUrl(attach.url, true)"
            >
              <img :src="attach.url" alt="" class="full-width fill-height" style="object-fit:contain;"/>
            </v-sheet>
            <v-sheet
                v-else-if="$tools.getFileTypeByPath(attach.url).includes('audio')"
                color="transparent" width="500"
            >
              <audio :src="attach.url" class="mt-2" controls>
                Прослушивание не поддерживается вашим браузером.
                <a :href="attach.url" target="_blank">Скачать</a>.
              </audio>
            </v-sheet>
            <v-sheet
                v-else-if="$tools.getFileTypeByPath(attach.url).includes('video')"
                class="clickable overflow-hidden" color="black" height="250" rounded width="250"
            >
              <video :src="attach.url" class="full-width fill-height" controls></video>
            </v-sheet>
            <div v-else-if="$tools.getFileTypeByPath(attach.url).includes('unknown')">
              <v-btn depressed small @click="$tools.openUrl(attach.url, true)">
                <v-icon class="mr-2" small>mdi-file</v-icon>
                Файл "{{ attach.url.split('.').pop().toLowerCase() }}"
              </v-btn>
            </div>
          </div>
          <div v-if="messageButtons.length>0" class="mt-1 mb-2 d-flex flex-wrap">
            <v-chip
                v-for="button in messageButtons"
                :key="button.id"
                class="mr-1 mb-1"
                label
                outlined
                small
            >
              {{ button.text }}
            </v-chip>
          </div>
        </div>

        <v-divider/>
        <div class="mx-2 py-1">
          <v-row class="caption font-weight-regular" no-gutters align="center">
            <v-col>
              <v-spacer/>
            </v-col>
            <v-col v-if="messageUser?.id===$store.state.user?.id && message.reaction!==null" class="text-no-wrap"
                   cols="auto"><h2>{{ message.reaction }}</h2></v-col>
            <v-col v-if="messageUser?.id===$store.state.user?.id && message.reaction!==null" class="text-no-wrap"
                   cols="auto">
              <dot/>
            </v-col>
            <v-col v-if="messageUser?.id!==$store.state.user?.id" class="text-no-wrap" cols="auto">
              <v-menu v-model="reactionMenu" offset-y z-index="100000">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon small :color="message.reaction===null ? '' : 'black'">
                    <v-icon v-if="message.reaction===null" small>mdi-emoticon-happy-outline</v-icon>
                    <h2 v-else>{{ message.reaction }}</h2>
                  </v-btn>
                </template>
                <v-sheet class="pa-2" width="220">
                  <div class="caption mb-1">Реакция</div>
                  <v-row dense no-gutters>
                    <v-col
                        v-for="emoji in reactions"
                        :key="emoji"
                        cols="3"
                        class="text-center"
                    >
                      <v-btn
                          :disabled="reactionLoading"
                          class="px-0"
                          height="40"
                          min-width="40"
                          text
                          block
                          @click="setReaction(emoji)"
                      >
                        <span class="text-h6" style="line-height: 1">{{ emoji }}</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-menu>
            </v-col>
            <v-col v-if="messageUser?.id!==$store.state.user?.id" class="text-no-wrap" cols="auto">
              <dot/>
            </v-col>
            <v-col class="text-no-wrap" cols="auto">
              <v-menu offset-y z-index="100000">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon small>
                    <v-icon small>mdi-history</v-icon>
                  </v-btn>
                </template>
                <v-sheet>
                  <div class="caption pa-2">История</div>
                  <v-simple-table v-if="message.dialogMessageLogs.length>0" dense>
                    <thead>
                    <tr>
                      <th>Пользователь</th>
                      <th>Действие</th>
                      <th>Дата / Время</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="v in message.dialogMessageLogs" :key="v.id">
                      <td class="text-no-wrap">
                        {{ v.dialogUser.user === null ? v.dialogUser.name : $tools.userFullName(v.dialogUser.user, true) }}
                      </td>
                      <td class="text-no-wrap">{{ v.type === 'read' ? 'Прочитано' : v.type }}</td>
                      <td class="text-no-wrap">{{ $tools.dateTime(v.created) }}</td>
                    </tr>
                    </tbody>
                  </v-simple-table>
                  <alert v-else style="min-width: 200px">Не найдено</alert>
                </v-sheet>
              </v-menu>
            </v-col>
            <v-col class="text-no-wrap" cols="auto">
              <dot/>
            </v-col>
            <v-col class="text-no-wrap" cols="auto">{{ $tools.dialogProviderName(message.dialogUser.provider) }}</v-col>
            <v-col class="text-no-wrap" cols="auto">
              <dot/>
            </v-col>
            <v-col class="text-no-wrap mr-1" cols="auto">{{ $tools.dateFormat(message.created) }}</v-col>
            <v-col class="text-no-wrap" cols="auto">
              <div v-if="
                message.dialogUser?.provider!=='internal' && message.readInternalUserProvider ?
                  true :
                  messageUser?.id===$store.state.user?.id ? messageReadAnother : messageReadMe
              ">
                <v-icon color="success" size="14">mdi-check-all</v-icon>
              </div>
              <div v-else>
                <v-icon size="14">mdi-check</v-icon>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import Dot from "../../../../componentsV2/base/Dot.vue";
import Alert from "../../../../componentsV2/base/Alert.vue";
import axios from "axios";

const REACTIONS = [
  '👍', '👎', '❤️', '😂', '😮', '😢',
  '😡', '🙏', '👏', '🔥', '✅', '❌',
  '🤔', '👋', '🎉', '💪', '😊', '😍',
];

export default {
  components: {Alert, Dot},
  props: ['message','cat'],
  data: () => ({
    messageClass: '',
    reactionMenu: false,
    reactionLoading: false,
    reactions: REACTIONS,
  }),
  computed: {
    messageAlign() {
      let align = 'start';
      if (this.messageUser?.id === this.$store.state.user?.id && this.message.dialogUser?.provider === 'internal')
        align = 'end';
      if (this.cat!=='internal' && this.message.dialogUser?.provider === 'internal')
        align = 'end';
      if (this.message.type === 'event')
        align = 'center';
      return align;
    },
    messageUser() {
      return this.message.dialogUser?.user
    },
    messageReadMe() {
      return this.message.dialogMessageLogs.filter(
          v => v.type === 'read' && v.dialogUser?.user?.id === this.$store.state.user?.id
      ).length > 0;
    },
    messageReadAnother() {
      return this.message.dialogMessageLogs.filter(
          v => v.type === 'read' && v.dialogUser?.user?.id !== this.$store.state.user?.id
      ).length > 0;
    },
    messageButtons() {
      return (this.message.buttons || [])
          .filter(Boolean)
          .slice()
          .sort((a, b) => (a.sort || 0) - (b.sort || 0));
    },
  },
  mounted() {
    if (this.message.new) {
      this.messageClass = 'blinkWarning';
      setTimeout(() => {
        this.messageClass = '';
        this.message.new = false;
      }, 2000)
    }
  },
  methods: {
    setReaction(emoji) {
      if (this.reactionLoading)
        return;

      this.reactionLoading = true;
      axios.put('/napi/dialog/message/' + this.message.id + '/reaction/', {
        data: emoji,
      }).then(() => {
        this.reactionMenu = false;
      }).finally(() => {
        this.reactionLoading = false;
      });
    },
  },
}
</script>